// extracted by mini-css-extract-plugin
export default {"watchListContainer":"_1BXz3Zyg9MVYBjx2k7jozi","loadingWrapper":"RY-4DsSKWGQD-w27ySAVP"};